// eslint-disable-next-line no-shadow
export enum Path {
  Home = '/',
  /**
   * Auth Pages
   */
  Login = '/login',
  ResetPassword = '/resetPassword',
  ForgetPassword = '/forgetPassword',
  CheckMail = '/checkMail',
  AdminVerifyEmail = '/verify-email',

  /**
   * Admin Pages
   * The rest can have the format of '/admin/[pageName]
   */
  Dashboard = '/admin/dashboard',
  Senders = '/admin/senders',
  Recipients = '/admin/recipients',
  Transactions = '/admin/transactions',

  BusinessModule = '/admin/businesses',
  BusinessUser = '/admin/business-user',
  BusinessDetailsId = '/admin/business-Detail-id/:id/:type',
  BusinessTransaction = '/admin/business-transaction',
  BusinessTransactionSender = '/admin/business-transaction/sender',
  BusinessTransactionReceiver = '/admin/business-transaction/receiver',
  BusinessRecipients = '/admin/business-recipients',
  BusinessCustomers = '/admin/business-customers',
  Agents = '/admin/agents',
  AgentTransactions = '/admin/agent-transactions',
  AgentTransactionsPayout = '/admin/agent-transactions/payout',
  AgentTransactionsCollection = '/admin/agent-transactions/collection',
  AgentCustomers = '/admin/agent-customers',

  Permission = '/admin/permissions',
  AdminUsers = '/admin/adminUsers',
  SuperAdmin = '/admin/superAdmins',
  TeamLead = '/admin/teamLeads',
  TeamMember = '/admin/teamMembers',
  Codes = '/admin/codes',
  CodesPaymentCode = '/admin/codes/payment-code',
  CodesDiscountCode = '/admin/codes/discount-code',
  RateAndFee = '/admin/rateAndFee',

  ActivityLogs = '/admin/activity-logs'
}
